module.exports = __WEBPACK_EXTERNAL_MODULE_69__;


//////////////////
// WEBPACK FOOTER
// external "vue"
// module id = 69
// module chunks = 0 1